import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Data } from '@angular/router';
import { CreateContractService } from "src/app/core/services/create-contract.service";

@Component({
  selector: 'app-signature-dialog',
  templateUrl: './signature-dialog.component.html',
  styleUrls: ['./signature-dialog.component.scss']
})
export class SignatureDialogComponent implements OnInit {

  public data: any;
  public optionsCustomer: any = [];
  public createSide: any = null;

  constructor(
    public dialogRef: MatDialogRef<SignatureDialogComponent>,
    public createContractService: CreateContractService
  ) { }

  ngOnInit() {
    const data = this.createContractService.signatureData.getValue();
    const user = this.createContractService.recordsPartySign.getValue();
    this.showSignatureFromData(data, user);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  saveData() {
    this.createContractService.signatureData.next(this.data);
    this.createContractService.cacheCustomerForSignature = JSON.parse(JSON.stringify(this.optionsCustomer));
    this.dialogRef.close();
  }

  showSignatureFromData(data: any, users: any) {
    this.createSide = users.find(user => user.isCreatedSide);
    const customers = users.filter(user => {
      return !user.isCreatedSide
    });
    this.optionsCustomer = customers;
    const dataDialog = JSON.parse(JSON.stringify(data));
    this.data = dataDialog.map(item => {
      if (item.signature) {
        const page = [];
        if (item.signature.positions) {
          item.signature.positions.forEach(pos => {
            if (pos.page && !page.includes(pos.page)) {
              page.push(pos.page);
            }
          });
        }
        item.signature.page = page.join(', ');
        if ((!item.signature.object || item.signature.object === 'CUSTOMER') && item.customerId) {
          const option = customers.find(cus => cus.customerId === item.customerId);
          if (!option) {
            item.customerId = null;
          }
        }
      }
      return item;
    });
  }

  checkDisabledOption(id) {
    const selected = this.data.find(item => item.customerId === id);
    return selected ? true : false;
  }
}
